import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CurriculumVersionForm } from '../Forms/CurriculumVersionForm';

type CurriculumVersionModalProps = {
  selectedUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const CurriculumVersionModal = ({ selectedUuid, isOpen, onClose }: CurriculumVersionModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width='s'
      title={selectedUuid ? t('curriculumVersion.edit') : t('curriculumVersion.add')}
      loading={loading}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <CurriculumVersionForm selectedUuid={selectedUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
